<template>
	<div class="select-pricepoint">
		<modal
			:modalTitle="pgDetails.DisplayName"
			:showModal="showModal">

			<div slot="body">
				<div class="form-group">
					<label v-for="(options, $index) in pricePoint" :key="$index"
						class="radio"
						:class="{ 'selected': selectedValue === options.val }">
						<input
							type="radio"
							class="checkbox custom-control-input"
							v-model="selectedValue"
							:id="options.val"
							:value="options.val"
							name="prices"/>

							<span class="input-radio"></span>
							<span class="checkbox-label">
								{{ options.label }}
							</span>
					</label>
				</div>

				<!--formSelect
					v-model="selectedValue"
					class="form-select-wrapper"
					:options="pricePoint"
					name="selectAmount"
					optionsValue="val"
					optionsLabel="label"
					required
					close-on-select
					:dontLocalize="true">
				</formSelect-->
			</div>
			<div slot="footer">
				<modalMultiButton
					btnPrimaryId="pricepointSubmit"
					btnSecondaryId="pricepointCancel"
					:btnPrimaryText="$t('wallet.pay-with', { pgName: pgDetails.DisplayName })"
					:btnSecondaryText="$t('wallet.cancel')"
					:loading="buttonLoading"
					:disabled="selectedValue === null"
					:primaryButtonClick="handleSelectPricePoint"
					:secondaryButtonHide="false"
					:secondaryButtonClick="handleCancelPricePoint">
				</modalMultiButton>
			</div>
		</modal>
	</div>
</template>

<script>
import modalMultiButton from '@arena/toolkit/src/components/common/modal-multi-buttons';
import formSelect from '@arena/toolkit/src/components/common/form-select';
import modal from '@arena/toolkit/src/components/common/modal';
import multiButton from '@arena/toolkit/src/components/common/multi-buttons';
import faqWidget from './common/faq-widget';
import accountInfoGroup from './common/account-info-group';
import pgButton from './common/pg-button';
import config from '../config/environment-config';

export default {
	name: 'selectPricepoint',
	components: {
		accountInfoGroup,
		formSelect,
		faqWidget,
		pgButton,
		modal,
		multiButton,
		modalMultiButton
	},
	props: {
		pgDetails: {
			type: Object,
			default: null
		},
		pricePoints: {
			default: null
		},
		showModal: {
			type: Boolean,
			default: false
		},
		cancelAction: {
			type: Function,
			default: null
		}
	},
	data() {
		return {
			buttonLoading: false,
			selectedValue: null,
		};
	},
	computed: {
		pricePoint() {
			return environment.region === 'global' ? this.pricePointSelectNX() : environment.region === 'tw' ? this.pricePointSelectPoints() : this.pricePointSelect(); // eslint-disable-line no-nested-ternary
		}
	},
	methods: {
		pricePointSelect() {
			return this.pricePoints.Amounts.map(
				pricePointAmount => ({
					val: pricePointAmount,
					label: this.pricePoints.Currency === 'NX' ?
						this.pricePoints.Currency + pricePointAmount :
						this.$n(pricePointAmount, 'currency', this.pricePoints.Currency)
				})
			);
		},
		pricePointSelectPoints() {
			return this.pricePoints.Amounts.map(
				pricePointAmount => ({
					val: pricePointAmount,
					label: `${this.$n(pricePointAmount, 'currency', this.pricePoints.Currency)} - ${this.$n(pricePointAmount)} ${this.$t('wallet.points')}`
				})
			);
		},
		pricePointSelectNX() {
			return this.pricePoints.Prices.map(
				pricePointAmount => ({
					val: pricePointAmount.ProductNo,
					label: `${this.$n(pricePointAmount.Amount, 'currency', this.pricePoints.Currency)} - ${this.$n(pricePointAmount.NxAmount)} NX`
				})
			);
		},
		handleSelectPricePoint() {
			this.buttonLoading = true;

			const params = {
				return_url: window.location.href,
				lang: this.$i18n.locale
			};

			if (environment.region === 'global') {
				Object.assign(params, {
					method_code: this.pgDetails.MethodCode,
					product_no: this.selectedValue,
					...(this.$store.state.addBalanceRedirectParams || {}),
				});
			} else {
				Object.assign(params, {
					amount: this.selectedValue,
					currency: this.pgDetails.Currency,
					method_name: this.pgDetails.MethodName,
				});
			}

			this.$walletAPI.checkoutToken(params)
				.then((response) => {
					const checkoutWebBaseURL = config[process.env.NODE_ENV][environment.region].checkout;
					window.location = `${checkoutWebBaseURL}?token=${encodeURI(response.data)}&goBackURL=${encodeURIComponent(window.location.href)}`;
				})
				.catch(() => {
					// console.log(error);
					this.buttonLoading = false;
				});
		},
		handleCancelPricePoint() {
			this.selectedValue = null;
			this.cancelAction();
		}
	},
	watch: {
		selectedValue(newVal) {
			dataLayer.push({
				event: 'pgAmountSelect',
				pgAmount: newVal
			});
		}
	},
	created() {
		const pricePointList = environment.region === 'global' ? this.pricePoints.Prices.map(d => d.ProductNo) : this.pricePoints.Amounts;
		if (pricePointList.length === 1) { // if there is only one, pre-select the one
			this.selectedValue = pricePointList[0];
		}
	}
};
</script>

<style lang="less" scoped>
	#commerce {
		.form-select-wrapper {
			margin-top: 0;
			width: 100%;
		}
	}
	.radio {
		height: 50px;
		border: 1px solid #d9d9d9;
		border-radius: 1px;
		cursor: pointer;
		color: #666;
		padding: 8px 15px;

		&.selected {
			border-color: #000;
		}
		.input-radio {
			width: 20px;
			height: 20px;
			background-color: #fff;
			border: 1px solid #666;
			top: 6px;
			margin-right: 10px;
			&:after {
				top: 4px;
				left: 4px;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				background-color: #000;
			}
		}
		input:checked ~ .input-radio {
			background-color: #fff;
		}
		input:checked ~ .checkbox-label {
			color: #000;
		}
		input:hover ~ .input-radio {
			background-color: #fff;
		}
		.checkbox-label {
			font-size: 14px;
			font-weight: bold;
			position: relative;
			top: 1px;
			display: inline-block;
		}
	}
	input:checked {
		html .radio {
			border-color:#00ffaa;
		}
	}
	.mobile,
	.launcher {
		.modal {
			position: absolute;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/select-pricepoint.vue